import {InferType, boolean, number, object, string} from 'yup';
import {
  MEMBERSHIP_VALIDATION_REGEX,
  PRE_AUTH_CODE_REGEX,
} from '$constants/regex';
import {VALIDATION_MESSAGES} from './constants';

export const patientInsuranceDetailFormSchema = object({
  selfPaying: boolean().nullable().required(VALIDATION_MESSAGES.SELECT_OPTION),
  paymentMode: string().nullable().notRequired(),
  insuranceId: number()
    .transform(value => (isNaN(value) ? undefined : value))
    .when('selfPaying', {
      is: false,
      then: schema => schema.required(VALIDATION_MESSAGES.INSURANCE_REQUIRED),
      otherwise: schema => schema.notRequired(),
    }),
  membershipNumber: string()
    .trim()
    .when(['selfPaying', 'insuranceId'], {
      is: (selfPaying: boolean, insuranceId: number) =>
        !selfPaying && !isNaN(insuranceId),
      then: schema => schema.required(VALIDATION_MESSAGES.MEMBERSHIP_REQUIRED),
      otherwise: schema => schema.notRequired(),
    })
    .matches(
      MEMBERSHIP_VALIDATION_REGEX,
      VALIDATION_MESSAGES.MEMBERSHIP_INVALID
    ),
  preAuthCode: string()
    .trim()
    .when('selfPaying', {
      is: false,
      then: schema =>
        schema
          .nullable()
          .notRequired()
          .transform(value => (value === '' ? undefined : value))
          .matches(
            PRE_AUTH_CODE_REGEX,
            VALIDATION_MESSAGES.PRE_AUTH_CODE_NUMBERS_ONLY
          )
          .optional(),
      otherwise: schema => schema.notRequired(),
    }),
  acceptResponsibility: boolean().when('selfPaying', {
    is: false,
    then: schema =>
      schema.oneOf([true], VALIDATION_MESSAGES.ACCEPT_RESPONSIBILITY),
    otherwise: schema => schema.notRequired(),
  }),
  consultant: object({
    id: number().required(),
  }).required(),
});

export type PatientInsuranceDetailFormData = InferType<
  typeof patientInsuranceDetailFormSchema
>;
